const STORAGE_KEY = "pv.notes_v1";

function load() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
  } catch { return {}; }
}

function save(obj) {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(obj)); } catch {}
}

// id-prefix: "town:<slug>" of "listing:<url>"
export function getNote(id) {
  return load()[id] || "";
}

export function setNote(id, text) {
  const obj = load();
  if (!text || !text.trim()) {
    delete obj[id];
  } else {
    obj[id] = text;
  }
  save(obj);
}

export function listNotedIds() {
  return Object.keys(load());
}
